import styled from 'styled-components';
import { ThemeInterface } from '../../interfaces/themeInterface';

export const ThemeSwitchButton = styled.button`
  border: 1px solid
    ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.32)' : 'rgba(0, 0, 0, 0.2)'};
  background: ${({ theme }: { theme: ThemeInterface }) =>
    theme.name === 'short'
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.13) 0%, rgba(255, 255, 255, 0.05) 100%)'
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.04) 100%)'};
  cursor: pointer;
  outline: 0;
  padding: 7px;
  border-radius: 11px;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  transition:
    transform 0.16s ease,
    opacity 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease;
  align-self: flex-end;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 1px 0
    ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.08)'};

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
    border-color: ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.28)'};
    background: ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short'
        ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.08) 100%)'
        : 'linear-gradient(180deg, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.06) 100%)'};
  }

  &:focus-visible {
    box-shadow:
      0 0 0 2px ${({ theme }: { theme: ThemeInterface }) =>
        theme.name === 'short' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.18)'},
      inset 0 1px 0
        ${({ theme }: { theme: ThemeInterface }) =>
          theme.name === 'short' ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.08)'};
  }

  svg {
    width: 17px;
    height: 17px;
    fill: ${({ theme }: { theme: ThemeInterface }) => theme.text};
    stroke: ${({ theme }: { theme: ThemeInterface }) => theme.text};
    opacity: 0.9;
  }
`;
